module.exports = __webpack_public_path__ + "static/media/b3bfa0d8-61a0-46f3-ae4c-1e9f7ad5e932.a8d8125b.JPG";